import SectionHeading from '@/pages/home/components/SectionHeading';
import useScrollReveal from '@/hooks/useScrollReveal';
import type { HomeTopic } from '@/pages/home/types';

interface TopicWallProps {
  topics: HomeTopic[];
  selected: string;
  onSelect: (id: string) => void;
}

export default function TopicWall({ topics, selected, onSelect }: TopicWallProps) {
  const { ref, visible } = useScrollReveal();

  return (
    <section id="topics" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-24">
      <div ref={ref} className={`w-full px-4 md:px-8 nh-reveal ${visible ? 'nh-in' : ''}`}>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            kicker="话题墙"
            title="按话题进入素材，而不是按热度排队"
            desc="话题覆盖直播录屏、未删减原视频、聊天记录截图与出处核查等方向。点选任意话题，下方的归档列表会同步筛选，方便你沿着同一条线索往下看。"
          />
          <div className="shrink-0 flex items-center gap-3 text-xs text-foreground-500">
            <span className="inline-flex w-6 h-6 items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-cursor-line"></i>
            </span>
            点选标签以筛选归档
          </div>
        </div>

        <div className="mt-10 flex flex-wrap gap-2 md:gap-3">
          {topics.map((topic) => {
            const active = topic.id === selected;
            return (
              <button
                key={topic.id}
                type="button"
                onClick={() => onSelect(topic.id)}
                className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  active
                    ? 'bg-primary-500 border-primary-500 text-background-50'
                    : 'bg-background-100 border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
                }`}
              >
                <span>{topic.name}</span>
                <span
                  className={`text-[11px] leading-none px-1.5 py-1 rounded-full ${
                    active ? 'bg-background-50/20 text-background-50' : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {topic.count}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}